const projectList = [
  {
    id: 0,
    name: "Vendo",
    description:
      "An unique solution that would help to include informal vendors in the public space development without compromising on the Urban Design.  ",
    image: require("./images/Vendos.png"),
    github: "https://github.com/gargananyae/SIH-vendo",
    tools: ["Next.js", "Dart", "Flutter", "MongoDB"],
  },
  {
    id: 1,
    name: "Luna",
    description:
      "An E-Commerce website for female menstrual and hygiene products with a AI Conversational chat bot",
    image: require("./images/Luna.png"),
    github: "https://github.com/xanthena/CodeRed_CSHTN-04",
    tools: ["HTML, CSS, JS", "Dialogflow", "Paytm API"],
    inView: false,
  },
  {
    id: 2,
    name: "Paws Hunter",
    description:
      "A website made for an NGO for helping and adopting injured and helpless animals ",
    image: require("./images/paws.png"),
    github: "https://github.com/Gaurav29502/need-for-code-11/tree/master",
    tools: ["React.js", "google maps API", "Mongo DB"],
    inView: false,
  },
  {
    id: 3,
    name: "Khayaal App",
    description:
      "App to aid the caretaker and family members in taking care of dementia patients",
    image: require("./images/khayaal.png"),
    website: "https://github.com/gargananyae/khayaal-TSEC-HACKS2022",
    github: "",
    tools: ["Android Studio", "Java", "XML"],
    inView: false,
  },

  {
    id: 4,
    name: "LDA",
    description:
      "To build a software that performs topic extraction and topic modelling in the field of online education. ",
    image: require("./images/LDA.png"),
    website: "",
    github: "https://github.com/gargananyae/TopMod",
    tools: ["Python"],
    inView: false,
  },

  {
    id: 5,
    name: "Regression Analysis",
    description: "Reaction rate constant prediction using regression analysis",
    image: require("./images/multireg.png"),
    github: "https://github.com/gargananyae/MultiReg",
    tools: ["Python", "Excel"],
    inView: false,
  },

  {
    id: 6,
    name: " Figma- Food Hunt",
    description:
      "A figma project (dashboard) made to experiment with masking and animation functionalities of Figma.",
    image: require("./images/FoodHunt.png"),
    github:
      "https://www.figma.com/proto/rbltYpSBOCKzZEdAiSc6Vt/Food-Hunt?node-id=1-2&starting-point-node-id=1%3A2",
    tools: ["Figma"],
    inView: false,
  },

  {
    id: 7,
    name: "Judo Class Web Design",
    description: "An initial level webpage design for my sister's Judo class.",
    image: require("./images/judo.png"),
    github:
      "https://www.figma.com/file/mp19dKRIV4PU4v9257Ir7K/Judo-tutorial-website?type=design&node-id=0-1&mode=design&t=2pbQ7uYec1SqD5rg-0",
    tools: ["Figma"],
    inView: false,
  },

  {
    id: 8,
    name: "Clueless- A fashion app",
    description:
      "UI for a fashion application currently being made for final year project.",
    image: require("./images/clueless.png"),
    github:
      "https://www.figma.com/file/eaFNL2dUAHqurkpjSJnhpm/Clueless?type=design&mode=design&t=2pbQ7uYec1SqD5rg-0",
    tools: ["Figma"],
    inView: false,
  },
];

export default projectList;
